module.exports = __webpack_public_path__ + "83d2d850d25ce2aaad9fd3020fe907cf.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-Bold.ttf
// module id = 26
// module chunks = 0